import { get, put } from 'api/request';
import urls from 'configs/urls';

export const getAllLabsWithFilters = queryString =>
  get(null, false, `${urls.labsModuleUrls.laboratoriesUrls.getlabsWithFilters}?${queryString}`);

export const addLab = data => put(null, false, urls.labsModuleUrls.laboratoriesUrls.addLab, data);
